import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { LeftNav } from "./LeftNav";
import { TopBar } from "./TopBar";
import { RightAlertRail } from "./RightAlertRail";
import { EventMarquee } from "./EventMarquee";
import CommandPalette from "@/components/command/CommandPalette";
import { useBootstrap } from "@/hooks/useBootstrap";
import { useLiveAlerts } from "@/hooks/useLiveAlerts";
import { useAudioCue } from "@/hooks/useAudioCue";
import { useAlertToasts } from "@/hooks/useAlertToasts";

export const AppShell = () => {
  const { data: bootstrap } = useBootstrap();
  const { alerts, kpi, matchContext, connected, updateAlertLocally } = useLiveAlerts({ max: 80 });
  const [cmdkOpen, setCmdkOpen] = useState(false);
  const [navExpanded, setNavExpanded] = useState(true);
  const [alertsExpanded, setAlertsExpanded] = useState(false);

  useAudioCue(alerts);
  useAlertToasts(alerts, { minSeverity: "medium" });

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background text-foreground">
      <LeftNav expanded={navExpanded} onToggle={() => setNavExpanded((v) => !v)} />

      <div className="flex-1 flex flex-col min-w-0">
        <TopBar bootstrap={bootstrap} kpi={kpi} matchContext={matchContext} connected={connected} />
        <EventMarquee alerts={alerts} />
        <main className="flex-1 overflow-hidden">
          <Outlet context={{ bootstrap, alerts, kpi, matchContext, connected, updateAlertLocally }} />
        </main>
      </div>

      <RightAlertRail
        alerts={alerts}
        onUpdate={updateAlertLocally}
        expanded={alertsExpanded}
        onToggle={() => setAlertsExpanded((v) => !v)}
      />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          unstyled: true,
          style: { fontFamily: "sans-serif" },
        }}
      />
      <CommandPalette open={cmdkOpen} setOpen={setCmdkOpen} />
    </div>
  );
};

export default AppShell;
